<template>
    <span v-if="row && row.readonly == true && colIndex == 0" v-html="row.html" @click="ExtraButtonClick"></span>
    <span v-else-if="valType == 'string'">{{ _format(value) }}</span>
    <span v-else-if="valType == 'date'">{{ value | dataFormat('YYYY/MM/DD') }}</span>
    <span v-else-if="valType == 'time'">{{ value | dataFormat('HH:mm') }}</span>
    <span v-else-if="valType == 'datetime'">{{ value | dataFormat((datetimeFormate && datetimeFormate.replace(/y/g, 'Y').replace(/d/g, 'D')) || 'YYYY/MM/DD HH:mm') }}</span>
    <span v-else-if="valType == 'select'">{{ _format(value) | selectFormat(_options) }}</span>
    <span v-else-if="valType == 'groupselect'">{{ value | selectFormat(_options) }}</span>
    <span v-else-if="valType == 'remoteselect'">{{ (value && value.label) || value }}</span>
    <span v-else-if="valType == 'tableselect'">{{ (value && value.label) || value }}</span>
    <span v-else-if="valType == 'remoteselecttable'">{{ (value && value.label) || value }}</span>
    <span v-else-if="valType == 'groupmultiselect'">{{ value | multiselectFormat(_options) }}</span>
    <span v-else-if="valType == 'radio'">{{ value | selectFormat(_options) }}</span>
    <span v-else-if="valType == 'checkbox'"></span>
    <span class="cus-icon" v-else-if="valType == 'icons'">
        <i v-if="icon.type == 1" :class="icon.val"></i>
        <font-awesome-icon v-else-if="icon.type == 2" :icon="icon.val"></font-awesome-icon>
        <i v-else></i>
    </span>
    <span v-else-if="valType == 'multiselect' && (allowCreate == false || allowCreate==undefined)">{{value | multiselectFormat(_select_tree_options) }}</span>
    <span v-else-if="valType == 'multiselect' && allowCreate==true">{{value | multiselectAllowCreateFormat(_select_tree_options) }}</span>
    <span v-else-if="valType == 'selecttree'">{{ value | multiselectFormat(_select_tree_options) }}</span>
    <span v-else-if="valType == 'bool'">{{ value | selectFormat(_options) }}</span>
    <span v-else-if="valType == 'rbool'">{{ value | selectFormat(_options) }}</span>
    <span v-else-if="valType == 'colorpicker'" :style="{ background: `rgb(${value})`, width: '30px', height: '20px', display: 'inline-block' }"></span>
    <span v-else-if="valType == 'imgicon'"><img style="width: 24px" :src="imgiconsrc" /></span>
    <span v-else-if="valType == 'selectnotCode'">{{ imgiconsrc }}</span>
    <!-- <span  v-else-if="valType=='buttongroup'">
    <item-input type="buttongroup" :options="_options" @extrabutton-click="ExtraButtonClick"></item-input>
  </span> -->
    <span v-else-if="valType == 'numberWithSlot'">{{ value ? slotValue + '-' + OrgFormat(value) : '' }}</span>
    <span v-else>{{ OrgFormat(value) }}</span>
</template>

<script>
export default {
    name: `TextFormatter`,
    props: [`value`, `allowCreate`, `options`, `type`, `datetimeFormate`, `col`, `row`, `colIndex`, `slotValue`,
        `decimal_places`],
    data() {
        return {
            // val:this.value,
            // _options:Object.assign({},this.options),
            valType: this.type
        }
    },
    computed: {
        _options() {
            if (this.options) {
                return _.isArray(this.options) ? this.options : this.$store.getters[this.options]
            }
            return []
        },
        _select_tree_options() {
            let ops = this.flatten(this._options)
            return ops
        },
        icon() {
            let r = {}
            if (this.value && this.value.indexOf(`:`) > -1) {
                r.val = this.value.split(`:`)
                r.type = r.val[0] == `iconfont` ? 1 : 2
            } else if (this.value) {
                r.type = 1
                r.val = this.value
            }
            return r
        },
        imgiconsrc() {
            let r = _.find(this.options, { value: this.value })
            return r && r.code || ``
        }
    },
    methods: {
        flatten(arr) {
            let ops = _.cloneDeep(arr)
            return [].concat(...ops.map(item => {
                if (item.children) {
                    let ops = [].concat(item, ...this.flatten(item.children))
                    delete item.children
                    return ops
                }
                return [].concat(item)
            }
            ))
        },
        ExtraButtonClick(e) {
            this.$emit(`extrabutton-click`, e)
        },
        OrgFormat(val) {
            if (val == `Invalid date`) {
                val = ``
            }
            if (this.row && this.col && this.col.format) {
                return this.col.format(this.row)
            }
            let result = val
            if (_.isArray(val) && val.length > 0) {
                let tmp = []
                val.forEach(d => {
                    if (d && d.label) {
                        tmp.push(d.label)
                    }
                })
                result = tmp.join(`,`)
            }

            // 处理后端 double 转 float 产生：0.30000000000000004 这种数据，后端改动大，讨论先前端处理
            if (this.type == `float` && this.decimal_places && this.decimal_places >= 0) {
                result = this.handleFloat(result)
            }
            return result
        },
        _format(val) {
            if (this.row && this.col && this.col.format) {
                return this.col.format(this.row)
            }
            return val
        },
        handleFloat(value) {
            let r = (value && `${value}`) || ``
            let pre = ``
            if (_.startsWith(r, `-`)) {
                pre = `-`
            }
            if (!_.startsWith(r, `0.`) && r.length >= 2) {
                r = _.trimStart(r, `0`)
            }
            if (r.indexOf(`.`) > -1) {
                let nums = this.decimal_places
                r = r.substr(0, r.indexOf(`.`) + nums + 1)
            }
            r = r.replace(/[^\d.]/g, ``)
            return pre + r
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/common/TextFormatter.vue